"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationReason = void 0;
var OperationReason;
(function (OperationReason) {
    OperationReason[OperationReason["USER"] = 0] = "USER";
    OperationReason[OperationReason["FS"] = 1] = "FS";
    OperationReason[OperationReason["RESYNC"] = 2] = "RESYNC";
})(OperationReason || (exports.OperationReason = OperationReason = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvb3BlcmF0aW9uYWwtdHJhbnNmb3Jtcy90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLGVBSVg7QUFKRCxXQUFZLGVBQWU7SUFDekIscURBQVEsQ0FBQTtJQUNSLGlEQUFNLENBQUE7SUFDTix5REFBVSxDQUFBO0FBQ1osQ0FBQyxFQUpXLGVBQWUsK0JBQWYsZUFBZSxRQUkxQiJ9